//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: '用户服务协议'
  },
  created: async function () {
    await this.getInfo();
  },
  data() {
    return {
      enterprise: this.params.enterpise || this.params.enterprise,
      protocolType: this.params.protocol_type,
      info: {}
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/protocol/page.vue